/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-28 14:07:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-08 14:51:59
 * @FilePath: \heshan_web\src\api\devicemon.js
 */
import request from '@/router/axios'


export function commandPage (query) {
  return request({
    url: '/api/data/command/page',
    method: 'get',
    params: query
  })
}

export function getDeviceListById (query) {
  return request({
    url: '/api/project/getDeviceListById',
    method: 'get',
    params: query
  })
}

export function getTowerAndStairsNumberByProjectId (query) {
  return request({
    url: '/api/project/getTowerAndStairsNumberByProjectId',
    method: 'get',
    params: query
  })
}

// // 设备监控点详情
export function devMonitorList (obj) {
  return request({
    url: 'api/data/monitor/list',
    method: 'get',
    params: obj
  })
}
// 获取多个监控点数据
export function multiplecurrent (obj) {
  return request({
    url: '/api/data/monitor/multiple/current',
    method: 'get',
    params: obj
  })
}

// 监控点操作
export function multiplewrite (obj) {
  return request({
    url: '/api/data/monitor/multiple/write',
    method: 'post',
    data: obj
  })
}
// 根据id获取定时器stid
export function getDeviceTimerStreamIdByDeviceId (obj) {
  return request({
    url:`/api/device/getDeviceTimerStreamIdByDeviceId`,
    method: 'get',
    params: obj
  })
}


// 查询空调详情
export function deviceinfo (obj) {
  return request({
    url:`api/device/${obj.id}`,
    method: 'get',
  
  })
}
// 查询醒目详情
export function projectinfo (obj) {
  return request({
    url:`api/project/${obj.id}`,
    method: 'get',
  
  })
}


// 历史数据
export function visualhistory (obj) {
  return request({
    url:`/api/data/monitor/visual/history`,
    method: 'get',
    params: obj
  })
}

// 历史数据表格
export function multiplehistory (obj) {
  return request({
    url:`/api/data/monitor/multiple/history`,
    method: 'get',
    params: obj,
  
  })
}
